module.exports = __webpack_public_path__ + "img/thumb_Atelier_6.df9fa42e.jpg";